import TemplateView from "../TemplateView"

export default class AddNewButton extends TemplateView {
    constructor({
        title = "",
        menu = null,
    }) {
        super()

        this.params = {
            title,
            menu,
        }
    }

    templateHtml() {
        return "<div class='addNewButton'>" +
               "  <div class='plusIcon'></div>" +
               "  <div class='title ellipsis'><%-title%></div>" +
               "  <div class='downIcon'></div>" +
               "</div>"
    }

    afterRender() {
        this.bindClick(() => this.params.menu.showAt(this.$el))
    }

    templateModel() {
        return {
            title: this.params.title,
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/AddNewButton.js